// Mail universal links: https://app.fincover.com/l/<app route>?w=<web path>
// (server utils.FillMailAppLink). With the mobile app installed the phone
// opens it there (Android App Links / iOS universal links claim /l/); in a
// browser this sends the user on to the web page in `w`, or — for app-only
// screens (no `w`) — shows an "open in the app" note.
//
// Returns true when it handled the page (the caller then skips the app boot).

const PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.finfor.fincover';

// Only same-site paths ("/LMS/…"), never "//host" or "https://…" (open redirect).
const safePath = (w) => typeof w === 'string' && /^\/(?![/\\])/.test(w);

const appOnlyPage = () => {
  const box = document.createElement('div');
  Object.assign(box.style, {
    fontFamily: 'system-ui, sans-serif', maxWidth: '420px', margin: '80px auto', padding: '0 16px',
    textAlign: 'center', color: '#1f2937',
  });
  const h = document.createElement('h2');
  h.textContent = 'Open this in the Fincover app';
  const p = document.createElement('p');
  p.textContent = 'This page is only available in the Fincover mobile app. Open this link on your phone with the app installed.';
  const get = document.createElement('a');
  get.href = PLAY_STORE;
  get.textContent = 'Get the app';
  const home = document.createElement('a');
  home.href = '/';
  home.textContent = 'Go to the website';
  [get, home].forEach((a) => Object.assign(a.style, { display: 'block', margin: '12px 0', color: '#2563eb' }));
  box.append(h, p, get, home);
  document.body.replaceChildren(box);
};

export const handleMailLink = () => {
  if (!window.location.pathname.startsWith('/l/')) return false;
  const w = new URLSearchParams(window.location.search).get('w');
  if (safePath(w)) {
    window.location.replace(w);
  } else {
    appOnlyPage();
  }
  return true;
};
